var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"action":"/action_page.php"}},[_c('v-container',{staticClass:"main-container responsive-height"},[_c('v-row',[_c('v-col',{attrs:{"xl":"6","lg":"6","md":"7","sm":"7","cols":"12"}},[_c('TransferAmount')],1),_c('v-col',{attrs:{"xl":"4","lg":"4","md":"5","sm":"5","cols":"12"}},[_c('TransferChart')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }